<template>
  <div dialog>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Dialog',
  };
</script>


<style scoped lang="stylus">
  @require '~@/style/type'
  @require '~@/style/colors'

  [dialog]
    background-color: #fff
    width: 560px
    border-radius: 4px
    overflow: hidden
    box-shadow: 0 30px 75px rgba(90, 30, 0, .1)

</style>
